import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QObjDBObject } from "./QObjDBObject";
import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QLoadRecordRFC extends QRFC {
  constructor() {
    super();
  }

  InitLoadRecordRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(org, user, data) {
    this.AddParameter("mode", "loadRecord");
    this.AddParameter("org", org);
    this.AddParameter("user", user);
    this.AddParameter("data", data);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];

    callBackObj.planMgr.HandleLoadRecordResponse(success, r["data"], r["positions"]);
    callBackObj.resolve?.(r);
    if (!success) {
      var w = new QAlert();
      w.InitAlert(
        appstr("Record Not Found"),
        appstr("Plan Load Record Failure"),
        Globals._wsMgr.GetBackgroundPanel(),
        Globals._wsMgr
      );
    }

    if (success && r["data"][0] != null) {
      var doc = Globals._wsMgr.GetDoc();
      var objDB = doc.GetObjDB();
      var boxClass = objDB.GetClassByName("Box");
      var dbObj = new QObjDBObject();
      dbObj.InitObject(boxClass);
      boxClass.ProcessObject(dbObj, r["data"][0]);
      if (callBackObj instanceof QObjDBObject) {
        callBackObj.fOutsidePlanSupervisor = dbObj;
      }
    }
    /*
  else {
      var w = new QAlert();
      w.InitAlert(
        appstr("Record Not Found"),
        appstr("Plan Load Record Failure"),
        Globals._wsMgr.GetBackgroundPanel(),
      );
      if (callBackObj instanceof QRevertManagerPanel) {
        callBackObj.fRecordNotFound = true;
        callBackObj.UpdatePanel();
      }
    } */

    callBackObj.planMgr.UpdateContext?.();

    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
